var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.25C2.1675 2.25 1.5 2.9175 1.5 3.75V6.75C1.5 7.5825 2.1675 8.25 3 8.25H6C6.8325 8.25 7.5 7.5825 7.5 6.75V3.75C7.5 2.9175 6.8325 2.25 6 2.25H3ZM6.15 3.375L6.945 4.1625L3.9525 7.125L2.055 5.2125L2.8575 4.425L3.96 5.5425L6.15 3.375ZM3 9.75C2.1675 9.75 1.5 10.4175 1.5 11.25V14.25C1.5 15.0825 2.1675 15.75 3 15.75H6C6.8325 15.75 7.5 15.0825 7.5 14.25V11.25C7.5 10.4175 6.8325 9.75 6 9.75H3ZM3 11.25H6V14.25H3V11.25ZM9 3.75H16.5V5.25H9V3.75ZM9 14.25V12.75H16.5V14.25H9ZM9 8.25H16.5V9.75H9V8.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.e29a6a6337c4abfb93bec6328913a527.svg";
export { ForwardRef as ReactComponent };